import { useState } from 'react';
import { AiCallFailedIcon, ArrowRed } from '../../assets';
import { Separator } from '../../components/navigation/navigation.styled';
import { P } from '../../styles';
import { Div, Icon } from '../../styles/styles';
import { lightTheme } from '../../styles/theme';
import {
  CustomerInfo,
  VDriveGetRecordingResponse,
} from '../../types/deliveries.types';
import { Audio } from '../Audio/Audio';
import { TextWithTooltipIcon } from '../Tooltips/Tooltips';
import { ReadTranscriptionModal } from './ReadTranscriptionModal';

export const CallRecordingAndTranscription = ({
  interceptorCallData,
  customerData,
}: {
  interceptorCallData: VDriveGetRecordingResponse;
  customerData: CustomerInfo | null | undefined;
}) => {
  const [showReadTranscriptionModal, setShowReadTranscriptionModal] =
    useState(false);

  const isAiCallFailed = interceptorCallData?.failed;

  return (
    <>
      <Div
        $background={lightTheme.gray}
        $borderRadius="16px"
        $mb="24px"
        $relative
        $p="8px 16px"
      >
        {isAiCallFailed && (
          <Div
            $absolute
            $top="0"
            $left="0"
            $right="0"
            $bottom="0"
            $flex
            $alignCenter
            $justifyCenter
            $gap="4px"
            $background={`${lightTheme.darkGray}BF`}
            $borderRadius="16px"
            $p="6px 0"
            $zIndex="1"
          >
            <AiCallFailedIcon />

            <TextWithTooltipIcon
              text="AI Call Failed"
              bold
              textColor={lightTheme.white}
              tooltip={`Fail details: ${
                interceptorCallData?.failDetails ?? '-'
              } <br /> Finish reason: ${
                interceptorCallData?.finishReason ?? '-'
              }`}
              color={lightTheme.white}
            />
          </Div>
        )}
        <Audio src={interceptorCallData?.recordingUrl || ''} />
        <Separator $m="6px 0" $color={lightTheme.lightGray} />
        <Div>
          <Div
            $flex
            $alignCenter
            $between
            $pointer
            onClick={() => setShowReadTranscriptionModal(true)}
            $minHeight="34px"
          >
            <P $m="0">Read Transcription</P>
            <Icon
              $background={lightTheme.gray}
              color={lightTheme.darkGray}
              $size="20"
              hoverBackgroundColor={`${lightTheme.darkGray}1A`}
            >
              <ArrowRed />
            </Icon>
          </Div>
        </Div>
      </Div>

      <ReadTranscriptionModal
        modalIsOpen={showReadTranscriptionModal}
        closeModal={() => setShowReadTranscriptionModal(false)}
        data={interceptorCallData?.transcription ?? []}
        customerName={customerData?.name ?? ''}
      />
    </>
  );
};
